export const capitalizeFirstLetter = (string) => {
    if (!string) return ''; // Handle empty or undefined strings
    return string.charAt(0).toUpperCase() + string.slice(1);
}
export const makeShortNumber = (number) => {
    if (!number) return ''; // Handle empty or undefined strings
    return `${number}`.length > 9 ? `${number}`.slice(0, 9) : `${number}`;
}